

document.addEventListener('teeinblue-event-component-injected', function() {
      const elementToMove = document.querySelector('.size-chart-button');
      const insertAfterElement = document.querySelector('#teeFormInputs');
      if (elementToMove && insertAfterElement) {        
       insertAfterElement.before(elementToMove)
      } 
});

function moveTeeFormResponses() {
  const teeFormResponses = document.querySelector('.tee-form-responses');
  const teeFormActions = document.querySelector('#teeFormActions');
  
  if (teeFormResponses && teeFormActions) {
    const contentToMove = teeFormResponses.innerHTML; 
    teeFormResponses.innerHTML = ''; 
    teeFormActions.insertAdjacentHTML('afterend', contentToMove); 
  }
}

function checkTeeFormResponses() {
  const teeFormResponses = document.querySelector('.tee-form-responses');
  if (teeFormResponses) {
    moveTeeFormResponses();
  }
}

function addClickListeners() {
  const atcButton = document.querySelector('.tee-btn--atc');
  const previewButton = document.querySelector('.tee-btn--preview');

  if (atcButton) {
    atcButton.addEventListener('click', () => {
      moveTeeFormResponses(); 
    });
  }

  if (previewButton) {
    previewButton.addEventListener('click', () => {
      moveTeeFormResponses(); 
    });

    const popupAtcButton = document.querySelector('.tee-dialog-gallery .tee-btn--atc'); 
    if (popupAtcButton) {
      popupAtcButton.addEventListener('click', () => {
        moveTeeFormResponses(); 
      });
    }
  }
}

document.addEventListener('teeinblue-event-component-injected', function() {
  addClickListeners();
  setInterval(checkTeeFormResponses, 500);
})

document.addEventListener('teeinblue-event-after-cart-added', function() {
  const checkPopupDOM = setInterval(function() {
    const teeFormResponses = document.querySelector('#teeFormActions+.tee-response');
    if (teeFormResponses) {
      clearInterval(checkPopupDOM);
      teeFormResponses.style.display = 'block'; 
      setTimeout(() => {
        teeFormResponses.style.display = 'none'; 
      }, 7500);
    }
  }, 100); 
})